import axios from "axios";

const idToken = localStorage.getItem("token");
const envData = process.env.REACT_APP_API_URL;

if(idToken === null || idToken === undefined) {
    // window.location.href = "/"
    // console.log('token invalid')
}
//console.log(envData.VITE_API_URL)
export default axios.create({
    baseURL: envData,
    headers : {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken
    }
});